<template>
    <div v-if="hasResults">
        <div class="subcaption text-grey-600 px-3 mb-1">{{ props.contents.placeHolders.stations }}</div>
        <div v-for="obj in state.stations">
            <div v-if="obj?.items?.length" class="caption text-grey-600 px-3">{{ obj.label }}</div>
            <div v-for="station in obj.items">
                <div
                    class="subcaption text-grey-900 cursor-pointer py-1 item px-3 cursor-pointer d-flex justify-content-between align-items-center"
                    @click="handleSelect(station)"
                    :class="{
                        'bg-primary-blue selected-item': isSelected(station.type, station.id, props.store)
                    }"
                >
                    <span>{{ station.label }}</span>
                    <template v-if="isSelected(station.type, station.id, props.store)">
                        <CloseButton />
                    </template>
                </div>
                <template v-if="station.stations">
                    <div
                        class="subcaption text-grey-900 cursor-pointer py-1 item d-flex justify-content-between align-items-center"
                        v-for="item in station.stations"
                        style="padding-left: 20px"
                        @click="handleSelect(item)"
                        :class="{
                            'bg-primary-blue selected-item': isSelected(item.type, item.id, props.store)
                        }"
                    >
                        <span>{{ item.label }}</span>
                        <template v-if="isSelected(item.type, item.id, props.store)">
                            <CloseButton />
                        </template>
                    </div>
                </template>
            </div>
        </div>
    </div>
</template>

<script lang="ts" setup>
import { computed } from 'vue'

// logic
import setSelected from '../../../logic/setSelected'
import isSelected from '../../../logic/isSelected'
import unselect from '../../../logic/unselect'

// state
import {AutocompleteState} from '../../../state/autocompleteState'

// enums
import { SeFields } from '../../../enums/seFields'

// components
import CloseButton from '../../../components/close-button.vue'

// props
const props = defineProps<{
    se: any
    store: any
    contents: any
    state: AutocompleteState
}>()

// Computed

const hasResults = computed(() => {
    const stationLengths = props.state.stations.map((station) => {
        return station?.items?.length
    })
    return stationLengths.filter((item) => item).length
})

// Methods
const handleSelect = (station: any) => {
    const { label, type } = station
    if (isSelected(type, station.id, props.store)) {
        handleUnselect(station)
    } else {
        select(station)
    }
}

const select = (station: any) => {
    const { label, type } = station
    setSelected(type, station.id, station.label, props.store)
    if (type === SeFields.STATION) {
        props.store.libs.se.batch(() => {
            props.se.setFieldValue(type, [station.id])

            props.store.libs.se.setFieldValue(SeFields.PARENT_STATION, undefined)
            props.store.libs.se.setFieldValue(SeFields.REGION, undefined)
            props.store.libs.se.setFieldValue(SeFields.DOMAINS, undefined)
        })
    }
    if (type === SeFields.PARENT_STATION) {
        props.store.libs.se.batch(() => {
            props.se.setFieldValue(type, [station.id])

            props.store.libs.se.setFieldValue(SeFields.STATION, undefined)
            props.store.libs.se.setFieldValue(SeFields.REGION, undefined)
            props.store.libs.se.setFieldValue(SeFields.DOMAINS, undefined)
        })
    }
}

const handleUnselect = (station: any) => {
    const { label, type } = station
    unselect(props.store)
    if (type === SeFields.STATION) {
        props.store.libs.se.setFieldValue(SeFields.STATION, undefined)
    }
    if (type === SeFields.PARENT_STATION) {
        props.store.libs.se.setFieldValue(SeFields.PARENT_STATION, undefined)
    }
}
</script>
